/* Pariyatti loader helper. The look is in piv-loader.css; this file only (1) offers window.pivLoader.html() to other
   scripts and (2) puts the quiet loader into pages that fill a list from a data sheet while the sheet is on its way
   (Pariyatti Presents: #piv-upcoming, #piv-grid; Podcasts: #ppc-list). The page's own script replaces the contents when
   the data arrives (or shows its own "could not load" message); a MutationObserver removes the loader in any case. */
(function () {
  function html(size, words) {
    return '<span class="piv-ld" role="status"><span class="piv-ld__icon" style="--s:' + (size || 34) + 'px" aria-hidden="true"></span>' +
      (words ? '<span>' + words + '</span>' : '') + '</span>';
  }
  window.pivLoader = { html: html };

  var TARGETS = [
    { sel: '#piv-upcoming', size: 44, words: 'Loading events…' },
    { sel: '#piv-grid', size: 52, words: 'Loading recordings…' },
    { sel: '#ppc-list', size: 52, words: 'Loading episodes…' }
  ];
  function stage(t) {
    var el = document.querySelector(t.sel);
    if (!el || el.childElementCount || el.textContent.trim()) return;
    var box = document.createElement('div');
    box.className = 'piv-ld-stage';
    box.setAttribute('data-piv-ld', '');
    box.innerHTML = html(t.size, t.words);
    el.appendChild(box);
    new MutationObserver(function () {
      var other = Array.prototype.some.call(el.childNodes, function (n) { return n !== box; });
      if (other && box.parentNode === el) box.remove();
    }).observe(el, { childList: true });
  }
  function init() { TARGETS.forEach(stage); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
